import { useNavigate } from "react-router";

import { Stack } from "@certa/catalyst/layouts/Stack";
import { Ellipsis } from "@certa/catalyst/components/Typography";

import { getDataObjectRoute } from "@certa/common/utils/routes";

import { DataObjectLogo } from "../DataObjectLogo/DataObjectLogo";

import styles from "./DataObjectTableCells.module.css";

type DataObjectNameCellProps = {
  logo?: string;
  name: string;
  uid: string;
  tag: string;
  shouldShowLogo?: boolean;
  onTrackClick?: () => void;
};

const ObjectLink = ({
  uid,
  name,
  objectType,
  onTrackClick
}: {
  uid: string;
  name: string;
  objectType: string;
  onTrackClick?: () => void;
}) => {
  const navigate = useNavigate();

  const onDataObjectClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    onTrackClick?.();
    navigate(
      getDataObjectRoute({
        objectType,
        objectId: uid,
        objectTab: "overview"
      })
    );
  };
  return (
    <a
      className={styles.dataObjectLink}
      href={getDataObjectRoute({
        objectType,
        objectId: uid,
        objectTab: "overview"
      })}
      onClick={evt => onDataObjectClick(evt)}
    >
      <Ellipsis>{name}</Ellipsis>
    </a>
  );
};

export const DataObjectNameCell = (props: DataObjectNameCellProps) => {
  const { logo, name, uid, tag, shouldShowLogo = true, onTrackClick } = props;

  return (
    <Stack direction="horizontal" gap="8" align="center">
      {shouldShowLogo ? <DataObjectLogo logo={logo} objectName={name} /> : null}
      <ObjectLink
        uid={uid}
        name={name}
        objectType={tag}
        onTrackClick={onTrackClick}
      />
    </Stack>
  );
};
